
<div class="signin-box-container scroll-bar-css">
  <!-- New Sign In Page -->
  <div class="signin-box-inner-container">
    <div class="col-12  sign-in-text">
      <div class="lg:col-6 lg:col-offset-3 md:col-8 md:col-offset-2 sm:col-12 sm:col-offset-0 sign-in-content">
        {{signInDescription}}</div>
    </div>
    <div class="col-12">
      <div class="col-12 md:col-4 lg:col-4 sm:col-12 lg:col-offset-4 md:col-offset-4 sm:col-offset-0 ">
        <p-panel>
          <div class="form-field col-12 ">
            <div class="text-center"><img [src]="logoPath"></div>
            <div class="form-field col-12 switch-btn">Reset Password</div>
          </div>
          <!-- <div class="form-field col-12">
            <div class="form-errors alert alert-danger" [hidden]='!loginErrors[0]["general"]'>
              <div *ngFor="let ErrorMessage of loginErrors['general']">
                {{ErrorMessage.message}}
              </div>
            </div>
          </div> -->
          <!-- <div class="form-field col-12">
            <div class="form-errors alert alert-danger" [hidden]='!loginErrors[0]["email"]'>
              <div *ngFor="let ErrorMessage of loginErrors['email']">
                {{ErrorMessage.message}}
              </div>
            </div>
          </div> -->

          
          <div class="form-field col-12">
            <div class="form-errors alert alert-danger" [hidden]='!changePasswordErrors[0]["general"]'>
              <div *ngFor="let ErrorMessage of changePasswordErrors['general']">
                {{ErrorMessage.message}}
              </div>
            </div>
          </div>
          

          <!-- <app-login></app-login> -->
          <form [formGroup]='setPasswordForm'>
            <div class="form-field  col-12 md:col-12 lg:col-12">
              <div class="form-label">
                <label for="email-label" translate>label_new_password</label>
              </div>
              <div class="form-control">
                <div class="form-control password-show">
                  <input formControlName="newPassword" id="username" class="full-width-transperent password-field" 
                  [type]="inputType" pInputText  />
                    <span class="eye-icon sign-in-eye" (click)="tooglePasswordType()">
                      <i *ngIf="inputType === 'password'" class="fa fa-fw fa-eye-slash" aria-hidden="true"></i>
                      <i *ngIf="inputType !== 'password'" class="fa fa-fw fa-eye" aria-hidden="true"></i>
                    </span>
                </div>
                <div class="form-errors"
                  *ngIf="setPasswordForm.controls.newPassword.errors  && (setPasswordForm.controls.newPassword.dirty || setPasswordForm.controls.newPassword.touched)">
                  <div [hidden]="!setPasswordForm.controls.newPassword.errors.required" translate>
                    error_new_password_required
                  </div>
                  <div [hidden]="!setPasswordForm.controls.newPassword.errors.minlength && !setPasswordForm.controls.newPassword.errors.pattern" translate>
                    error_password_validation
                  </div>
                  <!-- <div [hidden]="!setPasswordForm.controls.newPassword.errors.maxlength" translate>
                    exceed_max_length
                  </div> -->
                </div>
              </div>
            </div>
          
            <div class="form-field  col-12 md:col-12 lg:col-12">
              <div class="form-label">
                <label for="newConfirmPassword" translate>label_new_confirm_password</label>
              </div>
              <div class="form-control">
                <div class="form-control password-show">
                  <input pInputText [type]="cnfInputType" id="password" formControlName="newConfirmPassword" 
                  class="full-width-transperent password-field"/>
                    <span class="eye-icon sign-in-eye" (click)="toogleCnfPasswordType()">
                      <i *ngIf="cnfInputType === 'password'" class="fa fa-fw fa-eye-slash" aria-hidden="true"></i>
                      <i *ngIf="cnfInputType !== 'password'" class="fa fa-fw fa-eye" aria-hidden="true"></i>
                    </span>
                </div>
                <div class="form-errors"
                  *ngIf="setPasswordForm.controls.newConfirmPassword.errors  && (setPasswordForm.controls.newConfirmPassword.dirty || setPasswordForm.controls.newConfirmPassword.touched)">
                  <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.required" translate>
                    error_new_confirm_password_required
                  </div>
                  <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.minlength && !setPasswordForm.controls.newConfirmPassword.errors.pattern" translate>
                    error_password_validation
                  </div>
                  <!-- <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.maxlength" translate>
                    exceed_max_length
                  </div> -->
                </div>
              </div>
            </div>
          
            <div class="form-field col-12">
              <div class="form-field col-12 ">
                <img src=''>
              </div>
              <div class="form-field col-12 ">
                <button pButton appRipple label="Reset" class='sign-in-buttons' type="button" [disabled]="!setPasswordForm.valid"
                  (click)="doChangePassword()"></button>
              </div>
          
            </div>
          </form>

          <div style="clear: both;"></div>
        </p-panel>

    </div>
    <div  class="col-12 sign-in-text" style="text-align: center;position: fixed; bottom:0;padding-bottom:0;">
     
    </div>
  </div>
  
</div>

